export default __webpack_public_path__ + "static/media/habilitar-permiso-camara-windows-3.27118c86.svg";